import assignWith from 'lodash/assignWith';
import set from 'lodash/set';
import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { languages, translationMap } from './wording';
var detector = new LanguageDetector();
var isServerSide = typeof window === 'undefined';
if (!isServerSide) {
    detector.addDetector({
        name: 'userAgent',
        lookup: function () {
            var match = navigator.userAgent.match(/language\/([a-zA-Z'-_]+)/i);
            if (match) {
                return match[1].replace('_', '-');
            }
            return undefined;
        },
    });
}
var resources = {};
languages.forEach(function (lang, index) {
    var translation = assignWith({}, translationMap, function (objectValue, sourceValue) { return sourceValue[index]; });
    set(resources, [lang, 'translation'], translation);
});
export var i18nInstance = i18next.createInstance();
i18nInstance.use(detector).init({
    resources: resources,
    fallbackLng: {
        'zh-TW': ['zh-HK', 'zh-CN'],
        fil: ['tl-PH'],
        id: ['id-ID'],
        es: ['es-MX'],
        default: ['zh-CN'],
    },
    detection: {
        order: ['querystring', 'userAgent', 'cookie'],
        lookupCookie: 'language',
        caches: [],
    },
});
export function i18n(key) {
    return i18nInstance.t(key);
}
